export const LOAD_ALL_BATCH_JOBS_QUERY_ID = 'entityType:batchJob pageSize:10000'
